module.exports = __webpack_public_path__ + "img/broadcast-work-icon3.fe49c950.png";